import { Pipe, PipeTransform } from "@angular/core";
import { of, from } from "rxjs";
import { filter, tap, map } from "rxjs/operators";
import { log } from "util";

@Pipe({
  name: "Search", // Selector para HTML
})
export class SearchPipe implements PipeTransform {
  //  Value is gonna be the array of users -> users
  //  args returns everything that match -> args: Ri.... -> Richard, Ricardo, Ricardinho

  public transform(value: any, args: string) {
    if (!value) return; // When there isn't an array
    if (!args) return value; // When there isn't an input. Users don't type anything yet so all the users are shown

    args = args.toLowerCase();
    console.log(value);

    return from(value).pipe(
      map((array1: any) =>
        array1.filter((matches) =>
          JSON.stringify(matches).toLowerCase().includes(args)
        )
      ),
      tap((match) => console.log(match))
    );
  }
}
